import { AggregateDataReporter } from 'conversations-infrastructure/metrics/AggregateDataReporter';
const PAGE_ACTION_TITLE = 'usage-tracking-stats';
export const buildAggregateDataReporter = () => {
  return new AggregateDataReporter(data => {
    if (window.newrelic && window.newrelic.addPageAction) {
      window.newrelic.addPageAction(PAGE_ACTION_TITLE, data);
    }
  });
};